document.addEventListener('DOMContentLoaded', function() {
  const popup = document.getElementById('HlfToastPopup');
  const overlay = document.getElementById('HlfToastPopupOverlay');
  if (!popup || !overlay) return;

  const closeBtn = document.getElementById('HlfToastPopupClose');
  const declineBtn = document.getElementById('HlfToastPopupDecline');
  const ctaBtn = document.getElementById('HlfToastPopupCta');
  const copyBtn = document.getElementById('HlfToastCopyBtn');
  const copyLabel = copyBtn ? copyBtn.querySelector('.hlf-toast-popup__copy-label') : null;
  const timerDisplay = document.getElementById('HlfToastTimer');

  const storageKey = 'hlf_toast_popup_dismissed';

  // Don't show again this session once dismissed
  if (sessionStorage.getItem(storageKey)) {
    return;
  }

  let timerInterval;

  // Teleport to document.body so overlay covers entire window above all fixed/sticky elements
  function teleportToBody() {
    if (overlay && overlay.parentNode !== document.body) {
      document.body.appendChild(overlay);
    }
    if (popup && popup.parentNode !== document.body) {
      document.body.appendChild(popup);
    }
  }
  teleportToBody();

  function openPopup() {
    teleportToBody();
    overlay.classList.add('is-visible');
    popup.classList.add('is-visible');
    overlay.setAttribute('aria-hidden', 'false');
    popup.setAttribute('aria-hidden', 'false');
    document.body.classList.add('hlf-toast-popup-open');
    startTimer(15 * 60);
  }

  function closePopup() {
    overlay.classList.remove('is-visible');
    popup.classList.remove('is-visible');
    overlay.setAttribute('aria-hidden', 'true');
    popup.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('hlf-toast-popup-open');
    clearInterval(timerInterval);
    try {
      sessionStorage.setItem(storageKey, 'true');
    } catch (e) {}
  }

  function copyCode() {
    if (!copyBtn) return;
    const code = copyBtn.getAttribute('data-code') || 'FIRST300';
    if (!code) return;

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(() => {
        showCopiedState();
      }).catch(function(err) {
        fallbackCopy(code);
      });
    } else {
      fallbackCopy(code);
    }
  }

  function fallbackCopy(text) {
    try {
      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
      showCopiedState();
    } catch (e) {
      console.error('Fallback copy error:', e);
    }
  }

  function showCopiedState() {
    if (copyLabel) {
      const originalText = copyLabel.textContent;
      copyLabel.textContent = '\u2713 Copied!';
      copyBtn.classList.add('is-copied');

      setTimeout(() => {
        copyLabel.textContent = originalText;
        copyBtn.classList.remove('is-copied');
      }, 1800);
    }
  }

  // Show logic with data-delay
  const delay = parseInt(popup.getAttribute('data-delay') || '2000', 10);
  setTimeout(openPopup, delay);

  // Close interactions
  if (closeBtn) closeBtn.addEventListener('click', closePopup);
  if (declineBtn) declineBtn.addEventListener('click', closePopup);
  overlay.addEventListener('click', closePopup);
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && popup.classList.contains('is-visible')) {
      closePopup();
    }
  });

  // Copy button
  if (copyBtn) copyBtn.addEventListener('click', copyCode);

  // CTA button: copy code, show feedback, then close smoothly
  if (ctaBtn) {
    ctaBtn.addEventListener('click', function() {
      copyCode();
      setTimeout(closePopup, 700);
    });
  }

  // Countdown Timer
  function startTimer(duration) {
    let timer = duration, minutes, seconds;
    clearInterval(timerInterval);

    timerInterval = setInterval(() => {
      minutes = parseInt(timer / 60, 10);
      seconds = parseInt(timer % 60, 10);

      minutes = minutes < 10 ? '0' + minutes : minutes;
      seconds = seconds < 10 ? '0' + seconds : seconds;

      if (timerDisplay) {
        timerDisplay.textContent = minutes + ':' + seconds;
      }

      if (--timer < 0) {
        clearInterval(timerInterval);
      }
    }, 1000);
  }
});
